module.exports = __webpack_public_path__ + "img/歩く.51323deb.jpg";